var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49999 15.8333C5.15922 15.8333 3.98883 15.8333 3.14809 15.2716C2.78412 15.0284 2.47162 14.7159 2.22842 14.3519C1.66666 13.5112 1.66666 12.3408 1.66666 10C1.66666 7.65923 1.66666 6.48884 2.22842 5.6481C2.47162 5.28413 2.78412 4.97163 3.14809 4.72843C3.98883 4.16666 5.15922 4.16666 7.49999 4.16666L12.5 4.16666C14.8408 4.16666 16.0111 4.16666 16.8519 4.72843C17.2159 4.97163 17.5284 5.28413 17.7716 5.6481C18.3333 6.48884 18.3333 7.65923 18.3333 10C18.3333 12.3408 18.3333 13.5112 17.7716 14.3519C17.5284 14.7159 17.2159 15.0284 16.8519 15.2716C16.0111 15.8333 14.8408 15.8333 12.5 15.8333H7.49999Z",
    stroke: "#3F3F46",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5C11.3807 7.5 12.5 8.61929 12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10C7.5 8.61929 8.61929 7.5 10 7.5Z",
    stroke: "#3F3F46",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58334 12.5L4.58334 7.5",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 12.5L15.4167 7.5",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdle);
export default __webpack_public_path__ + "static/media/Idle.4753f8dad41d3f968d0507fc71716e60.svg";
export { ForwardRef as ReactComponent };